import styled from 'styled-components';

import { respondTo } from '../../styles/mixins';
import * as colors from '../../../common/styles/colors';

type Props = {
  fontSize: string;
};

export const StyledTitle = styled.h4<Partial<Props>>`
  text-align: center;
  color: ${colors.draxDarkBlue};
  font-size: ${(props: any) => props.fontSize || '28px'};
  margin: 0;

  ${respondTo.tablet`
    text-align: left;
  `}
`;
